import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=2ef3d3b8&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=2ef3d3b8&prod&scoped=true&lang=css"
import style1 from "./breadcrumb.vue?vue&type=style&index=1&id=2ef3d3b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3d3b8",
  null
  
)

export default component.exports